import { Overlay } from "@angular/cdk/overlay";
import { Component } from "@angular/core";
import { ProductModel } from "../../../models/product/product.model";
import { DialogService } from "../../../services/components/dialog.service";
import { RegisterInterestPopUpService } from "../../../services/components/register-interest-pop-up.service";
import { ProductPopUpBaseComponent } from "../product-pop-up-base/product-pop-up-base.component";

@Component({
  selector: "pcg-ng-register-interest-popup",
  template: require('./register-interest-pop-up.component.html')
})
export class RegisterInterestPopUpComponent extends ProductPopUpBaseComponent<ProductModel> {
    public constructor(
        popupService: RegisterInterestPopUpService,
        overlay: Overlay,
        dialogService: DialogService
    ) {
        super(popupService, overlay, dialogService);
    }
}
